export { isInFrame, getParentUrl };

const isInFrame = () => window.location !== window.parent.location;
const getParentUrl = () => isInFrame() ? document.referrer : document.location.href;